<template>
  <div>
    <Header/>
    <About/>
    <hr class="container"/>
    <Tours/>
    <AdBanner :backgroundImage="'banner-1.jpg'"/>
    <Places/>
    <hr class="container"/>
    <Blog/>
  </div>
</template>
<script type="text/javascript">

  import Header              from './Header'
  import About               from './About'
  import Tours               from './Tours'
  import AdBanner            from './AdBanner'
  import Places              from './Places'
  import Blog                from './Blog'
  export default {
    name:'Home',
    components: {
      Header,
      About,
      Tours,
      AdBanner,
      Places,
      Blog
    }
  }
</script>
